export default "__VITE_ASSET__DQDELMPz__"